<section class="form">
  <form [formGroup]="formTable" class="form_table" (ngSubmit)="addData()">
    <div
      class="style-input-default input_table"
      data-text="Banco *"
      [ngClass]="{ error: verificateInput('banco') }"
    >
      <select formControlName="banco">
        <option *ngFor="let banco of bancos" [value]="banco.nombre">
          {{ banco.nombre }}
        </option>
      </select>
    </div>
    <div
      class="style-input-default input_table"
      data-text="N° de cuenta *"
      [ngClass]="{ error: verificateInput('numero_cuenta') }"
    >
      <input
        type="text"
        maxlength="20"
        placeholder="N° de cuenta"
        onlyNumber
        formControlName="numero_cuenta"
      />
    </div>
    <button
      type="submit"
      *ngIf="!status"
      [disabled]="formTable.invalid || submit"
    >
      <i class="fas fa-plus"></i>
    </button>
  </form>
  <form [formGroup]="formFile" class="files">
    <div *ngIf="submitFile" class="clock-loader"></div>
    <button *ngIf="!file" (click)="downloadExcelTemplate()">
      <i class="fas fa-file-download"></i> Template
    </button>
    <i *ngIf="file" class="fas fa-save" (click)="saveFile()"></i>
    <i *ngIf="file" class="fas fa-times" (click)="clearFile()"></i>
    <!-- <label for="files">{{
      file ? file.name : "Cargar registros desde archivo"
    }}</label> -->
    <button
      mat-button
      class="primary-btn rounded btnFile"
      (click)="addFile()"
      *ngIf="!file"
    >
      Cargar registros desde archivo
    </button>
    <div class="fileName" *ngIf="file">
      <p class="nameFile">{{ file.name }}</p>
    </div>
    <!-- <input
      formControlName="file"
      type="file"
      id="files"
      class="select_file"
      accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      (click)="addFile($event)"
    /> -->
  </form>
</section>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="banco">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Banco</th>
      <td mat-cell *matCellDef="let element">{{ element.banco }}</td>
    </ng-container>

    <ng-container matColumnDef="numero_cuenta">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        N° de cuenta
      </th>
      <td mat-cell *matCellDef="let element">{{ element.numero_cuenta }}</td>
    </ng-container>

    <ng-container matColumnDef="opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removerCuenta(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
